export default class Textinput {
	constructor(element) {
		this.element = element;
		this.prepareInput()
	}

	prepareInput(){
		this.element.addEventListener('input', () => this.element.classList.add('active'))
		this.element.addEventListener('focusin', () => this.element.classList.add('active'))
		this.element.addEventListener('focusout', () => {
			if(this.element.querySelector('input').value === ""){
				this.element.classList.remove('active')
			}
		})
		if(this.element.querySelector('input').value !== ""){
			this.element.classList.add('active')
		}

		let pwButton = this.element.parentNode.querySelector('.showPassword');
		if(pwButton !== null) {
			pwButton.addEventListener('change', () => this.togglePwVisibility())
		}
	}

	togglePwVisibility() {
		let input = this.element.querySelector('input');
		if(input.type === 'password'){
			input.type = 'text'
		}
		else if(input.type === 'text') {
			input.type = 'password'
		}
	}

}
